export const FETCH_JOB = "FETCH_JOB";
export const FETCH_JOB_SUCCESS = "FETCH_JOB_SUCCESS";
export const FETCH_JOB_FAILURE = "FETCH_JOB_FAILURE";

export const FETCH_JOBS = "FETCH_JOBS";
export const FETCH_JOBS_SUCCESS = "FETCH_JOBS_SUCCESS";
export const FETCH_JOBS_FAILURE = "FETCH_JOBS_FAILURE";

export const CREATE_JOB = "CREATE_JOB";
export const CREATE_JOB_SUCCESS = "CREATE_JOB_SUCCESS";
export const CREATE_JOB_FAILURE = "CREATE_JOB_FAILURE";
export const CREATE_JOB_RESET = "CREATE_JOB_RESET";

export const CLONE_JOB = "CLONE_JOB";
export const CLONE_JOB_SUCCESS = "CLONE_JOB_SUCCESS";
export const CLONE_JOB_FAILURE = "CLONE_JOB_FAILURE";

export const CREATE_JOB_DOCUMENTS = "CREATE_JOB_DOCUMENTS";
export const CREATE_JOB_DOCUMENTS_SUCCESS = "CREATE_JOB_DOCUMENTS_SUCCESS";
export const CREATE_JOB_DOCUMENTS_FAILURE = "CREATE_JOB_DOCUMENTS_FAILURE";

export const CLEAR_JOB = "CLEAR_JOB";

export const FETCH_JOB_DATA = "FETCH_JOB_DATA";
export const FETCH_JOB_DATA_SUCCESS = "FETCH_JOB_DATA_SUCCESS";
export const FETCH_JOB_DATA_FAILURE = "FETCH_JOB_DATA_FAILURE";

export const FETCH_JOBS_FIELDS_ALL = "FETCH_JOBS_FIELDS_ALL";
export const FETCH_JOBS_FIELDS_ALL_SUCCESS = "FETCH_JOBS_FIELDS_ALL_SUCCESS";
export const FETCH_JOBS_FIELDS_ALL_FAILURE = "FETCH_JOBS_FIELDS_ALL_FAILURE";

// Embedding 26032024
export const UPDATE_JOB_EMBEDDINGS = "UPDATE_JOB_EMBEDDINGS";
export const UPDATE_JOB_EMBEDDINGS_SUCCESS = "UPDATE_JOB_EMBEDDINGS_SUCCESS";
export const UPDATE_JOB_EMBEDDINGS_FAILURE = "UPDATE_JOB_EMBEDDINGS_FAILURE";

export const CREATE_JOB_CUSTOM_VIEW = "CREATE_JOB_CUSTOM_VIEW";
export const CREATE_JOB_CUSTOM_VIEW_SUCCESS = "CREATE_JOB_CUSTOM_VIEW_SUCCESS";
export const CREATE_JOB_CUSTOM_VIEW_FAILURE = "CREATE_JOB_CUSTOM_VIEW_FAILURE";

export const FETCH_JOB_CUSTOM_VIEW = "FETCH_JOB_CUSTOM_VIEW";
export const FETCH_JOB_CUSTOM_VIEW_SUCCESS = "FETCH_JOB_CUSTOM_VIEW_SUCCESS";
export const FETCH_JOB_CUSTOM_VIEW_FAILURE = "FETCH_JOB_CUSTOM_VIEW_FAILURE";
export const RESET_JOB_CUSTOM_VIEW = "RESET_JOB_CUSTOM_VIEW";

export const SELECT_JOB_CUSTOM_VIEW = "SELECT_JOB_CUSTOM_VIEW";
export const SELECT_JOB_CUSTOM_VIEW_SUCCESS = "SELECT_JOB_CUSTOM_VIEW_SUCCESS";
export const SELECT_JOB_CUSTOM_VIEW_FAILURE = "SELECT_JOB_CUSTOM_VIEW_FAILURE";

export const DELETE_JOB_CUSTOM_VIEW = "DELETE_JOB_CUSTOM_VIEW";
export const DELETE_JOB_CUSTOM_VIEW_SUCCESS = "DELETE_JOB_CUSTOM_VIEW_SUCCESS";
export const DELETE_JOB_CUSTOM_VIEW_FAILURE = "DELETE_JOB_CUSTOM_VIEW_FAILURE";

export const FETCH_JOB_CUSTOM_VIEW_BY_ID = "FETCH_JOB_CUSTOM_VIEW_BY_ID";
export const FETCH_JOB_CUSTOM_VIEW_BY_ID_SUCCESS =
  "FETCH_JOB_CUSTOM_VIEW_BY_ID_SUCCESS";
export const FETCH_JOB_CUSTOM_VIEW_BY_ID_FAILURE =
  "FETCH_JOB_CUSTOM_VIEW_BY_ID_FAILURE";

export const EDIT_JOB_CUSTOM_VIEW_BY_ID = "EDIT_JOB_CUSTOM_VIEW_BY_ID";
export const EDIT_JOB_CUSTOM_VIEW_BY_ID_SUCCESS =
  "EDIT_JOB_CUSTOM_VIEW_BY_ID_SUCCESS";
export const EDIT_JOB_CUSTOM_VIEW_BY_ID_FAILURE =
  "EDIT_JOB_CUSTOM_VIEW_BY_ID_FAILURE";

export const UNSELECT_JOB_CUSTOM_VIEW = "UNSELECT_JOB_CUSTOM_VIEW";
export const UNSELECT_JOB_CUSTOM_VIEW_SUCCESS =
  "UNSELECT_JOB_CUSTOM_VIEW_SUCCESS";
export const UNSELECT_JOB_CUSTOM_VIEW_FAILURE =
  "UNSELECT_JOB_CUSTOM_VIEW_FAILURE";

// Job Default Custom View
export const SET_JOB_DEFAULT_CUSTOM_VIEW = "SET_JOB_DEFAULT_CUSTOM_VIEW";
export const DELETE_JOB_DEFAULT_CUSTOM_VIEW = "DELETE_JOB_DEFAULT_CUSTOM_VIEW";

// Get Recruiter By Job Id
export const FETCH_RECRUITER_BY_JOB_ID = "FETCH_RECRUITER_BY_JOB_ID";
export const FETCH_RECRUITER_BY_JOB_ID_SUCCESS =
  "FETCH_RECRUITER_BY_JOB_ID_SUCCESS";
export const FETCH_RECRUITER_BY_JOB_ID_FAILURE =
  "FETCH_RECRUITER_BY_JOB_ID_FAILURE";
export const FETCH_RECRUITER_BY_JOB_ID_RESET =
  "FETCH_RECRUITER_BY_JOB_ID_RESET";

export const FETCH_TOS_FIELDS_ALL = "FETCH_TOS_FIELDS_ALL";
export const FETCH_TOS_FIELDS_ALL_SUCCESS = "FETCH_TOS_FIELDS_ALL_SUCCESS";
export const FETCH_TOS_FIELDS_ALL_FAILURE = "FETCH_TOS_FIELDS_ALL_FAILURE";

export const FETCH_TOS_BY_JOB_ID = "FETCH_TOS_BY_JOB_ID";
export const FETCH_TOS_BY_JOB_ID_SUCCESS = "FETCH_TOS_BY_JOB_ID_SUCCESS";
export const FETCH_TOS_BY_JOB_ID_FAILURE = "FETCH_TOS_BY_JOB_ID_FAILURE";


// Save Job Pre-assessment Questions
export const SAVE_JOB_PRE_ASSESSMENT = "SAVE_JOB_PRE_ASSESSMENT";
export const SAVE_JOB_PRE_ASSESSMENT_SUCCESS = "SAVE_JOB_PRE_ASSESSMENT_SUCCESS";
export const SAVE_JOB_PRE_ASSESSMENT_FAILURE = "SAVE_JOB_PRE_ASSESSMENT_FAILURE";

// Fetch jobs to candidate mapping
export const FETCH_JOBS_TO_CANDIDATE_MAPPING = "FETCH_JOBS_TO_CANDIDATE_MAPPING";
export const FETCH_JOBS_TO_CANDIDATE_MAPPING_SUCCESS = "FETCH_JOBS_TO_CANDIDATE_MAPPING_SUCCESS";
export const FETCH_JOBS_TO_CANDIDATE_MAPPING_FAILURE = "FETCH_JOBS_TO_CANDIDATE_MAPPING_FAILURE";
export const RESET_JOBS_TO_CANDIDATE_MAPPING = "RESET_JOBS_TO_CANDIDATE_MAPPING";

